// Shared by Cloud Functions and the frontend (imported there as @shared).
// The pro draft: the lottery's odds and rookie contracts.

import {roundSalary} from "./contracts.js";

export const DRAFT_ROUNDS = 2;
// How many picks the lottery draws; the rest go by record.
export const LOTTERY_PICKS = 4;

// The NBA's chances (per 1000) for the 14 worst teams to win the top pick.
const NBA_ODDS = [140, 140, 140, 125, 105, 90, 75, 60, 45, 30, 20, 15, 10, 5];

/**
 * Lottery weights for `n` teams, worst record first: the NBA's table
 * stretched or squeezed to fit, as shares that sum to 1.
 * @param {number} n
 * @return {number[]}
 */
export function lotteryOdds(n) {
  if (n <= 0) return [];
  const raw = Array.from({length: n}, (_, i) =>
    NBA_ODDS[Math.min(NBA_ODDS.length - 1,
        Math.floor(i * NBA_ODDS.length / n))]);
  const sum = raw.reduce((a, b) => a + b, 0);
  return raw.map((w) => w / sum);
}

/**
 * The rookie contract for a pick: first-rounders on a sliding scale (about
 * 8% of the cap for the first pick) for four years, second-rounders the
 * minimum for two. Rookie contracts may go over the cap.
 * @param {number} pick overall pick, 1-based
 * @param {number} teams picks per round
 * @param {object} rules moneyRules
 * @return {object} {salary, years}
 */
export function rookieContract(pick, teams, rules) {
  if (pick > teams) return {salary: rules.minSalary, years: 2};
  const top = rules.cap * 0.08;
  const salary = top * Math.pow(1 - (pick - 1) / teams, 1.5);
  return {salary: Math.max(rules.minSalary, roundSalary(salary)), years: 4};
}

/**
 * Whether managers may set their draft queue now: from the lottery (the
 * season's review) until draft day.
 * @param {object} league
 * @return {boolean}
 */
export function draftQueueOpen(league) {
  const s = league?.season;
  return league?.type === "pro" && s?.phase === "offseason" &&
    ["review", "development", "resign"].includes(s.offseason?.stage);
}
